if (!customElements.get('pk-crystal-editorial')) customElements.define('pk-crystal-editorial', class extends HTMLElement {
  connectedCallback() {
    this.config = JSON.parse(this.querySelector('script').textContent);
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
      const specs = data.html?.querySelector(`pk-product-specs[data-product-id="${this.dataset.productId}"] .pk-specs`);
      if (!specs) return;
      const variantId = specs.dataset.variantId;
      if (variantId) this.sync(String(variantId));
    });
  }
  sync(variantId) {
    const active = this.config.variant_ids.includes(variantId);
    document.querySelectorAll(`[data-pk-crystal-for="${this.dataset.productId}"]`).forEach(region => {
      region.hidden = region.hasAttribute('data-pk-crystal-only') ? !active : active;
      if (region.hidden) region.querySelectorAll('video').forEach(video => video.pause());
    });
    const video = document.querySelector(`video[data-pk-crystal-film="${this.dataset.productId}"]`);
    const source = video?.querySelector('source');
    const woven = this.config.story_key === 'woven';
    const src = active ? (woven ? this.config.story_video : this.config.blessing_video) : video?.dataset.fallbackSrc;
    if (source && source.getAttribute('src') !== src) {
      video.pause(); source.src = src;
      video.poster = active ? (woven ? this.config.story_poster : this.config.blessing_poster) : video.dataset.fallbackPoster;
      video.load();
      const play = video.parentElement.querySelector('.pk-dzi-film__play');
      if (play) play.hidden = false;
    }
    window.dispatchEvent(new Event('resize'));
  }
  disconnectedCallback() { this.unsubscribe?.(); }
});
